import { useEffect, useMemo, useRef, useState } from "react";
import restaurantImages from "../generated/images/restaurantSliderManifest";
import "./styling/customSlider.css";

const MAIN_WIDTHS = [480, 768];
const THUMB_WIDTH = 480;
const buildSrcSet = (img, format, widths) =>
  widths.map((w) => `${img[format][w]} ${w}w`).join(", ");

function CustomSlider() {
  const imageKeys = useMemo(
    () =>
      Object.keys(restaurantImages).sort((a, b) => Number(a) - Number(b)),
    []
  );

  const [currentIndex, setCurrentIndex] = useState(0);
  const thumbsContainerRef = useRef(null);
  const thumbRefs = useRef({});

  const total = imageKeys.length;

  useEffect(() => {
    if (!total) return undefined;
    const id = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % total);
    }, 6500);
    return () => clearInterval(id);
  }, [total]);

  useEffect(() => {
  const container = thumbsContainerRef.current;
  const activeThumb = thumbRefs.current[currentIndex];
  if (!container || !activeThumb) return;

  const targetLeft =
    activeThumb.offsetLeft - (container.clientWidth / 2) + (activeThumb.clientWidth / 2);

  container.scrollTo({
    left: Math.max(0, targetLeft),
    behavior: "smooth",
  });
}, [currentIndex]);

  useEffect(() => {
    if (!total) return;
    const preloadIndexes = [
      currentIndex,
      (currentIndex + 1) % total,
      (currentIndex + 2) % total,
      (currentIndex - 1 + total) % total,
    ];

    preloadIndexes.forEach((idx) => {
      const key = imageKeys[idx];
      const img = restaurantImages[key];
      const pre = new Image();
      pre.src = img.webp[768] || img.jpg[768];
    });
  }, [currentIndex, imageKeys, total]);

  if (!total) return null;

  const currentKey = imageKeys[currentIndex];
  const currentImage = restaurantImages[currentKey];

  return (
    <div className="customSlider">
      <div className="customSliderMain">
        <picture>
          <source
            type="image/avif"
            srcSet={buildSrcSet(currentImage, "avif", MAIN_WIDTHS)}
            sizes="(max-width: 1200px) 100vw, 768px"
          />
          <source
            type="image/webp"
            srcSet={buildSrcSet(currentImage, "webp", MAIN_WIDTHS)}
            sizes="(max-width: 1200px) 100vw, 768px"
          />
          <img
            className="customSliderMainImage"
            src={currentImage.jpg[768]}
            srcSet={buildSrcSet(currentImage, "jpg", MAIN_WIDTHS)}
            sizes="(max-width: 1200px) 100vw, 768px"
            width="768"
            height="600"
            alt=""
            loading="eager"
            decoding="async"
          />
        </picture>
      </div>

      <div className="customSliderThumbRow">
        <div className="customSliderThumbs" ref={thumbsContainerRef}>
          {imageKeys.map((key, idx) => {
            const img = restaurantImages[key];
            const active = idx === currentIndex;
            return (
              <button
                key={`thumb-${key}`}
                type="button"
                className={`customSliderThumb ${active ? "active" : ""}`}
                onClick={() => setCurrentIndex(idx)}
                aria-label={`Ga naar afbeelding ${idx + 1}`}
                ref={(el) => {
                  thumbRefs.current[idx] = el;
                }}
              >
                <img
                  src={img.jpg[THUMB_WIDTH]}
                  width="120"
                  height="100"
                  loading="lazy"
                  decoding="async"
                  alt=""
                />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default CustomSlider;
